module.exports = __webpack_public_path__ + "img/ico_talk.aee846b3.svg";